import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TenantService } from '../services/tenant.service';

/**
 * HTTP interceptor that adds X-Tenant-ID header to all outgoing requests.
 * Required for multi-tenancy support on the backend.
 */
export const tenantInterceptor: HttpInterceptorFn = (req, next) => {
    const tenantService = inject(TenantService);
    const tenantId = tenantService.id();

    // Skip if no tenant resolved (e.g., during login flow)
    if (!tenantId) {
        return next(req);
    }

    const clonedReq = req.clone({
        headers: req.headers.set('X-Tenant-ID', tenantId),
    });

    return next(clonedReq);
};
